import QueryString from "qs";

export const savProductsQuery = () =>
  QueryString.stringify(
    {
      fields: ["id", "name"],
    },
    { encodeValuesOnly: true },
  );
export const ticketSavsQuery = (userId, userRole) =>
  QueryString.stringify(
    {
      sort: ["createdAt:desc"],
      fields: [
        "id",
        "name",
        "deliveryDate",
        "refClient",
        "status",
        "serialNumber",
        "warrantyEndDate",
        "problem",
        "createdAt",
        "relaunch",
        "relaunchTitle",
      ],
      populate: {
        intervention: true,
        users_permissions_users: {
          fields: ["id", "firstName", "lastName", "userRole"],
        },
        product: {
          fields: ["id", "name", "name_en"],
        },
        savOrders: {
          fields: ["id"],
        },
        commandes_from_sav: {
          fields: ["id", "createdAt", "status", "number"],
          populate: {
            packings: {
              fields: ["id", "name"],
              populate: {
                model: {
                  fields: ["id", "name"],
                },
              },
            },
          },
        },
        order: {
          fields: ["id", "realRefClient", "oldId", "slug"],
        },
        commande: {
          fields: ["id", "number", "oldId"],
        },
        reseller: {
          fields: ["id", "name"],
          populate: {
            business_affiliate: {
              fields: ["id"],
              populate: {
                users_permissions_users: {
                  fields: ["id", "firstName", "lastName", "userRole"],
                },
              },
            },
          },
        },
        notifications: {
          populate: {
            sender: true,
            comment: true,
          },
          filters: {
            $and: [
              {
                read: {
                  $eq: false,
                },
              },
              {
                recipient: {
                  id: {
                    $eq: userId,
                  },
                },
              },
              userRole !== 1
                ? {
                    comment: {
                      $or: [
                        {
                          onlyAdmin: {
                            $eq: false,
                          },
                        },
                        {
                          onlyAdmin: {
                            $null: true,
                          },
                        },
                      ],
                    },
                  }
                : {},
            ],
          },
        },
      },
    },
    { encodeValuesOnly: true },
  );

export const ticketSavQuery = (userId, userRole) =>
  QueryString.stringify(
    {
      fields: [
        "id",
        "name",
        "deliveryDate",
        "refClient",
        "status",
        "serialNumber",
        "warrantyEndDate",
        "problem",
        "createdAt",
        "relaunch",
        "relaunchTitle",
        "explanation",
      ],
      populate: {
        attachments: {
          fields: ["id", "title", "createdAt"],
          populate: {
            file: { fields: "*" },
          },
        },
        product: {
          fields: ["id", "name", "name_en"],
        },
        order: {
          fields: ["id", "realRefClient", "oldId", "slug"],
        },
        commande: {
          fields: ["id", "number", "oldId"],
        },
        savOrders: {
          fields: ["id", "createdAt", "status"],
          populate: {
            panier_items: {
              fields: ["id"],
              populate: {
                product: {
                  fields: ["id", "name", "name_en"],
                },
              },
            },
          },
        },
        commandes_from_sav: {
          fields: ["id", "createdAt", "status", "number"],
          populate: {
            packings: {
              fields: ["id", "name"],
              populate: {
                model: {
                  fields: ["id", "name"],
                },
              },
            },
          },
        },
        reseller: {
          fields: ["id", "name"],
          populate: {
            business_affiliate: {
              fields: ["id"],
              populate: {
                user: {
                  fields: ["id", "firstName", "lastName", "userRole"],
                },
              },
            },
          },
        },
        intervention: {
          fields: "*",
        },
        users_permissions_users: {
          fields: ["id", "firstName", "lastName", "userRole"],
          populate: {
            photo: true,
          },
        },
        notifications: {
          populate: {
            sender: true,
            comment: true,
          },
          filters: {
            $and: [
              {
                read: {
                  $eq: false,
                },
              },
              {
                recipient: {
                  id: {
                    $eq: userId,
                  },
                },
              },
              userRole !== 1
                ? {
                    comment: {
                      $or: [
                        {
                          onlyAdmin: {
                            $eq: false,
                          },
                        },
                        {
                          onlyAdmin: {
                            $null: true,
                          },
                        },
                      ],
                    },
                  }
                : {},
            ],
          },
        },
      },
    },
    { encodeValuesOnly: true },
  );
